import Sentry from 'utils/sentry';
function open({ message }) {
    if (typeof window !== 'undefined' &&
        typeof window.navigator !== 'undefined' &&
        window.navigator.share) {
        return window.navigator.share({ text: message });
    }
    return Promise.reject(new Error('Web Share API is not supported in this browser.'));
}
/**
 * Opens the Web Share sheet without throwing when the user dismisses it.
 * Real failures are still reported to Sentry.
 */
export const openShare = (options) => open(options).catch((error) => {
    if (error instanceof Error && error.name === 'AbortError')
        return undefined;
    Sentry.captureException(error instanceof Error ? error : new Error(String(error)));
    return undefined;
});
const Share = {
    open,
    shareSingle: open,
    isPackageInstalled: () => false,
};
export default Share;
